import styled from 'styled-components';

export const ButtonGroup = styled.div`
  display: none;

  @media only screen and (max-width: 580px) {
     display: flex;
  }
`;
